<template>
  <div class="bookItem-container" v-bar>
    <div>
      <div>
        <el-row :gutter="50">
          <el-col
            v-for="(item, index) in booksData"
            :key="item.id"
            :xs="24"
            :sm="24"
            :md="24"
            :lg="12"
            :xl="12"
          >
            <div class="bookItem-content">
              <el-checkbox
                v-if="selectCtrl"
                class="bookItem-checkbox"
                v-model="item.checked"
                @change="$emit('selectEvn', item)"
              ></el-checkbox>
              <img
                class="bookItem-cover"
                v-if="item.cover"
                :src="item.cover"
                alt=""
                @click="checkBookDetail(item)"
              />
              <img
                class="bookItem-cover"
                v-else
                src="@/assets/img/cmb_book_cover.png"
                alt=""
                @click="checkBookDetail(item)"
              />
              <div class="bookItem-content-info">
                <p class="bookItem-content-name omitText">{{ item.name }}</p>
                <div class="bookItem-content-btn" v-if="component === 'list'">
                  <button
                    @click.stop="deleteBook(item)"
                    class="global-button-style"
                  >
                    {{ $t("commonMsg.del") }}
                  </button>
                  <button
                    @click.stop="moveBook(item)"
                    class="global-button-style"
                  >
                    {{ $t("content.books.addTo") }}
                  </button>
                </div>
                <div class="bookItem-content-btn" v-else>
                  <p v-if="item.status === 0">
                    {{ $t("content.books.soldOut") }}
                  </p>
                  <p v-else-if="item.status === 1">
                    {{ $t("content.books.soldOn") }}
                  </p>
                  <p>{{ $t("content.books.price") }}：{{ item.price || 0 }}</p>
                  <!-- <el-rate v-model="rateVal" disabled></el-rate>
                  <div>
                    <span class="bookItem-content-views"
                      >{{ $t("content.books.views") }}：9080</span
                    >
                    <span class="bookItem-content-sales"
                      >{{ $t("content.books.sales") }}：121</span
                    >
                  </div> -->
                  <!--<button @click.stop='editBook(item)' class="global-button-style">{{$t('commonMsg.edit')}}</button>-->
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    booksData: {
      type: Array,
    },
    component: {
      type: String,
      default: "list",
    },
    selectCtrl: {
      type: Boolean,
    },
  },
  computed: {
    isJD() {
      return parseInt(this.$route.query.source) === 4;
    },
  },
  data() {
    return {
      rateVal: 3,
    };
  },
  methods: {
    checkBookDetail(item) {
      this.$emit("checkBookDetail", item);
    },
    deleteBook(item) {
      this.$emit("delEvn", item);
    },
    moveBook(item) {
      this.$emit("moveEvn", item);
    },
    //        editBook(item) {
    //            this.$emit('editBook', item)
    //        },
    soldOut() {},
  },
};
</script>

<style lang="scss" scoped>
.bookItem-container {
  flex: 1;
  overflow: hidden;
  > div {
    overflow: hidden;
  }
  .bookItem-content {
    /* height: 170px; */
    padding: 20px 10px 10px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    > .bookItem-cover {
      cursor: pointer;
      width: 100px;
      min-width: 100px;
      height: 140px;
    }
    .bookItem-checkbox {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    .bookItem-content-info {
      overflow: hidden;
      box-sizing: border-box;
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      justify-content: space-between;
      .bookItem-content-name {
        padding-right: 40px;
        margin-bottom: 40px;
      }
      .bookItem-content-btn {
        .bookItem-content-views {
          margin-right: 20px;
        }
        > button {
          margin: 0;
        }
      }
    }
  }
}
</style>
